import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { DocumentsListCard } from '../documentsListCard/DocumentsListCard.js';
import 'clsx';
import '../../base/addButton/AddButton.module.scss.js';
import '../../base/alert/Alert.js';
import '../../base/breadcrumb/Breadcrumb.module.scss.js';
import '../../base/button/Button.js';
import 'react-aria';
import 'react-stately';
import 'react';
import '../../base/iconButton/IconButton.js';
import '../../base/calendar/Calendar.module.scss.js';
import 'dayjs';
import '../../base/calendar/calendarGrid/CalendarGrid.module.scss.js';
import '../../base/calendar/calendarGrid/calendarCell/CalendarCell.module.scss.js';
import '../../base/carBackground/CarBackground.module.scss.js';
import '../../base/loader/Loader.module.scss.js';
import '../../base/carLoader/CarLoader.module.scss.js';
import '../../base/card/Card.js';
import '../../base/confirmation/Confirmation.js';
import '../../base/modal/Modal.js';
import '../../base/confirmationModal/ConfirmationModal.module.scss.js';
import '../../base/error/Error.module.scss.js';
import '../../base/tag/Tag.module.scss.js';
import '../../base/vehicleQuote/VehicleQuote.module.scss.js';
import '../../base/insuranceQuote/InsuranceQuote.module.scss.js';
import '../../base/listBox/ListBox.js';
import { ListCard } from '../../base/listCard/ListCard.js';
import 'react-dom';
import 'react-transition-group';
import '../../base/popover/Popover.module.scss.js';
import '../../base/progressBar/ProgressBar.module.scss.js';
import '../../base/toast/context/ToastContext.js';
import '../../base/toast/Toast.module.scss.js';
import '../../base/toast/context/ToastContext.module.scss.js';
import '../../base/tooltip/Tooltip.module.scss.js';
import { documentsTypes } from '../documentsTypes/index.js';
import styles from './DocumentsSummaryCards.module.scss.js';

var mainGroupDocumentsIds = [
    documentsTypes.DECLARATIONS_PAGE,
    documentsTypes.ID_CARD,
    documentsTypes.ENDORSEMENT_COVER_LETTER,
    documentsTypes.KEY_FACTS_SHEET,
    documentsTypes.KEY_FACTS_SHEET_2,
    documentsTypes.KEY_FACTS_SHEET_3,
    documentsTypes.DRIVERS_CLUB,
    documentsTypes.BILLING_SCHEDULE,
];
var privacyPolicyDocumentsIds = [documentsTypes.PRIVACY_POLICY_HAGERTY, documentsTypes.PRIVACY_POLICY];
var DocumentsSummaryCards = function (_a) {
    var documents = _a.documents, onViewClick = _a.onViewClick, footerRenderer = _a.footerRenderer;
    var hasBillingSchedule = !!documents.find(function (doc) { return doc.Id === documentsTypes.BILLING_SCHEDULE; });
    var mainGroupDocuments = documents
        .filter(function (doc) { return mainGroupDocumentsIds.includes(doc.Id); })
        .sort(function (a, b) { return (mainGroupDocumentsIds.indexOf(b.Id) > mainGroupDocumentsIds.indexOf(a.Id) ? -1 : 1); });
    var privacyPolicyDocuments = documents.filter(function (doc) { return privacyPolicyDocumentsIds.includes(doc.Id); });
    return (jsxs(Fragment, { children: [jsx(DocumentsListCard, { header: jsx(ListCard.Header, __assign({ className: styles.privacyPolicyGroupHeader }, { children: "Current policy" })), footer: jsx(ListCard.Footer, __assign({ className: styles.mainGroupFooter }, { children: footerRenderer(hasBillingSchedule) })), documents: mainGroupDocuments, onViewClick: onViewClick, hideDates: true, showIcons: true }), privacyPolicyDocuments.length > 0 && (jsx(DocumentsListCard, { header: jsx(ListCard.Header, __assign({ className: styles.privacyPolicyGroupHeader }, { children: "Privacy policy" })), className: styles.privacyPolicyGroup, documents: privacyPolicyDocuments, onViewClick: onViewClick, hideDates: true, showIcons: true }))] }));
};

export { DocumentsSummaryCards };
